import { useState } from "react";

import { CurriculumItem } from "../../../types/CurriculumItem";


interface CurriculumProps {
  curriculum: CurriculumItem[];
  curriculumIntro?: string;
}



// const faq_data: DataType[] = [
//    {
//       id: 1,
//       title: "Introduction",
//       show: "show",
//       faq_details: [
//          {
//             class_name: "open-item",
//             lock: false,
//             title: "Course Installation",
//             duration: "03:03"
//          },
//          {
//             lock: true,
//             title: "Create a Simple React App",
//             duration: "07:48"
//          },
//          {
//             lock: true,
//             title: "React for the Rest of us",
//             duration: "10:48"
//          },
//       ]
//    },
//    {
//       id: 2,
//       title: "Capacitance and Inductance",
//       collapsed: "collapsed",
//       faq_details: [
//          {
//             lock: true,
//             title: "Course Installation",
//             duration: "03:03"
//          },
//          {
//             lock: true,
//             title: "Create a Simple React App",
//             duration: "07:48"
//          },
//          {
//             lock: true,
//             title: "React for the Rest of us",
//             duration: "10:48"
//          },
//       ]
//    },
//    {
//       id: 3,
//       title: "Final Audit",
//       collapsed: "collapsed",
//       faq_details: [
//          {
//             lock: true,
//             title: "Course Installation",
//             duration: "03:03"
//          },
//          {
//             lock: true,
//             title: "Create a Simple React App",
//             duration: "07:48"
//          },
//          {
//             lock: true,
//             title: "React for the Rest of us",
//             duration: "10:48"
//          },
//       ]
//    },
// ];

const Curriculum = ({ curriculum ,curriculumIntro  }: CurriculumProps) => {

   const [activeAccordion, setActiveAccordion] = useState<number | null>(null);

const toggleAccordion = (id: number) => {
  setActiveAccordion(prev => (prev === id ? null : id));
};

   return (
      <>
         <div className="courses__curriculum-wrap">
            <h3 className="title">Course Curriculum</h3>
           <p>{curriculumIntro}</p>
            <div className="accordion" id="accordionExample">
         {
         
curriculum.map(item => (
  <div key={item.curriculum_id} className="accordion-item">
    <h2 className="accordion-header" id={`heading${item.curriculum_id}`}>
      <button
        className={`accordion-button ${activeAccordion === item.curriculum_id ? '' : 'collapsed'}`}
        type="button"
        onClick={() => toggleAccordion(item.curriculum_id)}
        aria-expanded={activeAccordion === item.curriculum_id}
        aria-controls={`collapse${item.curriculum_id}`}
      >
        {item.session_number}: {item.session_title}
      </button>
    </h2>
    <div
      id={`collapse${item.curriculum_id}`}
      className={`accordion-collapse collapse ${activeAccordion === item.curriculum_id ? 'show' : ''}`}
      aria-labelledby={`heading${item.curriculum_id}`}
      data-bs-parent="#accordionExample"
    >
      <div className="accordion-body">
        <p><strong>Covered:</strong> {item.covered}</p>
        <p><strong>Outcome:</strong> {item.outcome}</p>
      </div>
    </div>
  </div>
))



         
         }
         </div>

         </div>
       
      </>
   )
}

export default Curriculum
